'use client';
import Link from 'next/link';
import Image from 'next/image';
import { usePathname } from 'next/navigation';
import { UserNav } from './user-nav';
import { SidePanel } from './side-panel';
import { useIsMobile } from '@/hooks/use-mobile';
import { useState, useEffect } from 'react';

export default function Header() {
  const isMobile = useIsMobile();
  const pathname = usePathname();
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (pathname === '/') {
        setScrolled(window.scrollY > window.innerHeight);
      } else {
        setScrolled(window.scrollY > 0);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [pathname]);

  const isLandingPage = pathname === '/';

  return (
    <header
      className={`w-full bg-light-sage-green transition-all duration-300 z-50 ${
        isLandingPage
          ? scrolled
            ? 'fixed top-0 shadow-md'
            : 'absolute top-0'
          : 'sticky top-0 shadow-md'
      }`}>
      <div className="container flex h-14 items-center">
        <div className="flex-1 flex items-center">
          <Link href="/" className="flex items-center">
            <Image
              src="/sm_logo.svg"
              alt="SM Logo"
              width={32}
              height={32}
              className="h-8 w-8"
            />
          </Link>
        </div>
        <div className="flex-1 flex justify-center"></div>
        <div className="flex-1 flex justify-end">
          {isMobile ? <SidePanel /> : <UserNav />}
        </div>
      </div>
    </header>
  );
}
